import {useFirebaseState} from "./firebaseContext";

export const useCheckIfAdmin = () => {
    const {admin} = useFirebaseState()
    return admin
}